'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _user = require('../actions/user');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(setUser),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(setUserLangauge),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(userSaga);

function setUser(actions) {
  var accountToken, getAccountByKey, getAccountByKeyHeader, userData;
  return _regenerator2.default.wrap(function setUser$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          getAccountByKey = new _webUtils.API();
          getAccountByKeyHeader = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }];
          _context.next = 5;
          return getAccountByKey.get(_webUtils.Urls.getAccountByKey + '?languageId=' + (actions.language === 'en' ? 1 : 2), getAccountByKeyHeader);

        case 5:
          userData = _context.sent;

          if (!_webUtils.STATUS.isSuccess(userData.status)) {
            _context.next = 12;
            break;
          }

          _webUtils.Cookie.set(_webUtils.Cookie.CULTURE, actions.language + '-' + userData.data.CountryIsoCode);
          _context.next = 10;
          return (0, _effects.put)({
            type: _user.USER.SET_USER_DONE,
            user: userData.data
          });

        case 10:
          _context.next = 14;
          break;

        case 12:
          _context.next = 14;
          return (0, _effects.put)({
            type: _user.USER.SET_USER_FAIL,
            err: userData.data
          });

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function setUserLangauge(actions) {
  var accountKey, languageId, reload, setUserDefaultLangauge, setUserDefaultLangaugeHeaders, language;
  return _regenerator2.default.wrap(function setUserLangauge$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          accountKey = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad.unique_name;
          languageId = actions.languageId, reload = actions.reload;
          setUserDefaultLangauge = new _webUtils.API();
          setUserDefaultLangaugeHeaders = [{
            key: 'AccountKey',
            value: accountKey
          }];
          _context2.next = 6;
          return setUserDefaultLangauge.post(_webUtils.Urls.account.setUserDefaultLangauge, {
            DefaultLanguageId: languageId
          }, setUserDefaultLangaugeHeaders);

        case 6:
          language = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(language.status)) {
            _context2.next = 13;
            break;
          }

          _context2.next = 10;
          return (0, _effects.put)({
            type: _user.USER.SET_USER_LANGUAGE_DONE
          });

        case 10:
          if (reload) {
            _webUtils.Cookie.set(_webUtils.Cookie.LANGUAGE, '' + (languageId === 1 ? 'en' : 'ar'));
            window.location.reload();
          }
          _context2.next = 15;
          break;

        case 13:
          _context2.next = 15;
          return (0, _effects.put)({
            type: _user.USER.SET_USER_LANGUAGE_FAIL,
            err: language.data
          });

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function userSaga() {
  return _regenerator2.default.wrap(function userSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_user.USER.GET_USER, setUser);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(_user.USER.SET_USER_LANGUAGE, setUserLangauge);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = userSaga;
module.exports = exports['default'];